export const getApiUrl = () => {
    const API_ENDPOINT = 'https://svbkapi.aautipay.com'
    // const API_ENDPOINT = `http://localhost:5000`
    // const API_ENDPOINT = `http://10.30.3.122:5000`
    return API_ENDPOINT;
  }

export const awsAccessKey = 'AKIARDYJVAUPGSK7TVOD'
export const awsSecretKey = '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'
export const awsBucketImage = 'svbk-lms/svbkcdfiles'
export const awaBucketAudio = 'svbk-lms/svbkaudiofiles'

export const phoneNumber = "0863-2232405, 9390115480"
export const email = "accounts@svbk.in"
export const address = "Sri venkateswara Bala Kuteer, Syamala Nagar, Guntur-522006, A.P."

export const pending = "Pending"
export const approved = "Approved"
export const rejected = "Rejected"
export const editing = "Editing"

export const templateApproval = 'templateApproval'
export const discountApproval =  'discountApproval'

export const razorpayKey = 'rzp_live_zdLen5i4S2GX08'
export const razorpaySecret = 'ek6dSNO2VvHbKpuikxKYK70a'
